// extracted by mini-css-extract-plugin
module.exports = {"content":"HeroCarouselContent_content__1ge50","header":"HeroCarouselContent_header__17UJw"};